// extracted by mini-css-extract-plugin
export default {"avatar":"avatar-circle_avatar__8q9ac","selected":"avatar-circle_selected__Y-0Mb","empty_mode":"avatar-circle_empty_mode__ZXRqA"};